import { css } from '@huspy/styled-system/css';

const creditsTopSectionStyles = {
  container: css({
    paddingY: 5,
    paddingX: 8,
    borderRadius: 5,
    background: 'linear-gradient(54.66deg, #0E4160 0%, #4A7E8F 87.2%)',
    width: '100%',
  }),
  availableCreditsContainer: css({
    position: 'relative',
    width: 'fit-content',
  }),
  creditsIconContainer: css({
    position: 'absolute',
    width: '48px',
    bottom: '8px',
    right: '-45px',
  }),
};

export default creditsTopSectionStyles;
